export default __webpack_public_path__ + "static/me-b31b20a73f2869f71dd3462d4f676d40.png";